// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/a28ce4a8d428589c41b4.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"890aab634c6505cf00af","180":"864b39379f123076ae95","245":"a2f8d58e07af2c07f381","246":"3ebbc9b5049364584639","247":"dec89fd89a096f1f2302"}[chunkId] + ".chunk.js";
};